import { useCallback, useRef, useState } from "react";
import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";
import { useFocusTrap } from "@/hooks/useFocusTrap";
import { useMediaQueryEffect } from "@/hooks/useMediaQueryEffect";

const DESKTOP_HEADER_MEDIA_QUERY = "(min-width: 1041px)";

export function useHeaderMobileMenu() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const toggleRef = useRef<HTMLButtonElement>(null);

  const close = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => {
    setOpen((currentOpen) => !currentOpen);
  }, []);
  const closeOnDesktop = useCallback(
    (matches: boolean) => {
      if (matches) close();
    },
    [close],
  );

  useBodyScrollLock(open);
  useFocusTrap({
    active: open,
    containerRef: menuRef,
    restoreFocusRef: toggleRef,
    onEscape: close,
  });
  useMediaQueryEffect(DESKTOP_HEADER_MEDIA_QUERY, closeOnDesktop);

  return {
    close,
    menuRef,
    open,
    toggle,
    toggleRef,
  };
}
